import React, { useCallback, useMemo } from 'react';
import { Avatar, Space } from 'antd';
import {
  AllergyIcon,
  AvatarPlaceholderIcon,
  CakeIcon,
  CalendarIcon,
  HandHeartIcon,
} from 'components/common/SVGIcon';
import { GENDERS } from 'configs/localData';
import { getAge } from 'utils/textUtils';
import { FORMAT_DATE_PICKER } from 'configs/localData/constant';
import { formatDate } from 'utils/tools';
import { useTranslation } from 'react-i18next';
import ContactInfoItem from '../ContactInfoItem';
import { ChildCardStyles } from '../styles';

const ChildCard = ({ childItem }) => {
  const genderItem = useMemo(
    () =>
      GENDERS.find(
        (gender) => gender.value === childItem.gender?.toLowerCase(),
      ),
    [childItem.gender],
  );

  const { t } = useTranslation();

  const getAllergiesAndNeedsValue = useCallback(
    (value) => {
      const text = value?.trim();
      return {
        yesOrNo: text ? t('text.yes') : t('text.no'),
        className: text
          ? 'text-warning fw-bold'
          : 'text-success-default fw-bold',
        hasArrowIcon: !!text,
        detailedValue: text,
      };
    },
    [t],
  );

  const childInformations = [
    {
      value: formatDate(childItem?.dateOfBirth, FORMAT_DATE_PICKER),
      icon: <CalendarIcon />,
    },
    {
      value: getAge(childItem.dateOfBirth),
      icon: <CakeIcon />,
    },
    {
      value: `${t('contacts.allergies')}:`,
      extraValue: {
        ...getAllergiesAndNeedsValue(childItem?.allergies),
        detailedTitle: t('contacts.detailedAllergies'),
      },
      icon: <AllergyIcon />,
    },
    {
      value: `${t('contacts.specialNeeds')}:`,
      extraValue: {
        ...getAllergiesAndNeedsValue(childItem?.specialNeeds),
        detailedTitle: t('contacts.detailedNeeds'),
      },
      icon: <HandHeartIcon />,
    },
  ];

  return (
    <ChildCardStyles className="rounded-12 relative bg-white border-neutral-200 p-16">
      <div className="flex items-center">
        <div>
          <Avatar
            src={childItem?.avatar}
            icon={<AvatarPlaceholderIcon className="text-gray-400" />}
          />
        </div>

        <div className="ml-8">
          <span className="text-20 fw-bold text-black-800">{`${childItem?.firstName} ${childItem?.lastName}`}</span>
          <span className="ml-4 text-20">
            {genderItem?.icon && (
              <genderItem.icon
                style={{
                  color: genderItem.color,
                }}
              />
            )}
          </span>
        </div>
      </div>
      <Space className="flex mt-8" direction="vertical">
        {childInformations?.map((item, index) => (
          <ContactInfoItem
            key={index}
            value={item?.value}
            icon={item?.icon}
            className="text-16 text-gray-700"
            extraValue={item?.extraValue}
          />
        ))}
      </Space>
    </ChildCardStyles>
  );
};

export default ChildCard;
